import React from 'react';
import { FetchStatus } from '../../../util/FetchStatus';
import { URLData } from '@telia-common-components/shared';
import ErrorUtil from '../../../util/ErrorUtil';
import API from '../../../util/ApiUtil';
export const Go3AppDataProvider = (props) => {
    const [isSsoLoaded, setIsSsoLoaded] = React.useState(props.isSsoLoaded);
    const [teliaWebSelfServiceUrl, setTeliaWebSelfServiceUrl] = React.useState(props.teliaWebSelfServiceUrl);
    const [go3AppDataState, setGo3AppDataState] = React.useState({
        status: FetchStatus.UNINITIALIZED,
        data: null,
    });
    const urlData = new URLData({ ...props, lang: props.language });
    const commonApi = API(urlData.commonAPIBaseURL, {
        timeout: 20000,
    });
    const fetchGo3AppData = async () => {
        try {
            setGo3AppDataState({ status: FetchStatus.FETCHING, data: null });
            const { data } = await commonApi.get(`/go3/apps-info?language=${props.language}`);
            setGo3AppDataState({ status: FetchStatus.FETCHED, data });
        }
        catch (e) {
            ErrorUtil.pushErrorToTeliaRumAndLog(e);
            setGo3AppDataState({ status: FetchStatus.ERROR, data: null });
        }
    };
    React.useEffect(() => {
        setIsSsoLoaded(props.isSsoLoaded);
        setTeliaWebSelfServiceUrl(props.teliaWebSelfServiceUrl);
    }, [props.isSsoLoaded]);
    return (React.createElement(Go3AppDataContext.Provider, { value: {
            isSsoLoaded,
            openSsoFrame: props.openSsoFrame,
            teliaWebSelfServiceUrl,
            ensureLoginWithGotoUrl: props.ensureLoginWithGotoUrl,
            go3AppDataState,
            fetchGo3AppData,
        } }, props.children));
};
export const Go3AppDataContext = React.createContext({
    isSsoLoaded: false,
    openSsoFrame: () => undefined,
    teliaWebSelfServiceUrl: '',
    ensureLoginWithGotoUrl: () => undefined,
    go3AppDataState: undefined,
    fetchGo3AppData: () => undefined,
});
export const useGo3AppData = () => {
    return React.useContext(Go3AppDataContext);
};
